import { Expose } from 'class-transformer';

export default class NutritionData {
  static diets: {[key: string]: string} = {
    vegan: "Vegan",
    vegetarian: "Vegetarian"
  }
  static allergens: {[key: string]: string} = {
    eggs: "Eggs",
    fish: "Fish",
    milk: "Milk",
    peanuts: "Peanuts",
    shellfish: "Shellfish",
    soy: "Soy",
    tree_nuts: "Tree Nuts",
    wheat: "Wheat",
    gluten: "Gluten",
    sesame: "Sesame",
  }
}